import * as React from "react"
const SeparationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={23}
    height={23}
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 512 512"
    {...props}
  >
    <g fill="#fff">
      <path
        d="M501.084 295.982h-17.462v-22.126c0-5.57-4.515-10.086-10.086-10.086h-5.964c.709-8.717-4.914-16.938-13.672-19.189l-57.62-14.81 18.561-48.611c5.374-14.076-1.673-29.852-15.761-35.231l-42.49-16.44c-8.143-3.151-16.891-3.956-25.479-2.38-33.716 6.185-89.129 16.352-95.531 17.522a18.305 18.305 0 0 0-10.802 6.327l-37.719 45.523V59.369a12.055 12.055 0 0 0-8.678-11.573l-81.14-23.68h210.377v89.025l24.112-3.15V12.06c0-6.658-5.398-12.056-12.056-12.056-1.709 0-306.832-.027-307.764.05C5.526.58.841 5.946.841 12.06c0 2.958-.057 440.79.104 442.075.613 4.872 4.095 8.755 8.575 10.064l162.107 47.309c7.723 2.257 15.433-3.561 15.433-11.573V250.25a18.165 18.165 0 0 0 7.416-5.339l54.243-65.467 60.479-11.061-40.764 106.762s1.453-3.672-25.712 89.318l-31.614 60.093v56.934h.001c9.305 2.27 19.27-1.977 23.908-10.795l46.438-88.273a21.346 21.346 0 0 0 1.597-3.948l25.689-87.938 5.789 2.21 44.751 70.286-32.169 90.604c-3.94 11.096 1.861 23.286 12.958 27.226 11.036 3.919 23.279-1.841 27.226-12.958l35.651-100.411a21.33 21.33 0 0 0-2.107-18.585l-31.286-49.137 13.584-35.578 28.807 7.405-.263 24.386H394.22c-2.269 0-4.355.759-6.039 2.022l26.713 41.955c6.327 9.937 7.695 22.004 3.754 33.106l-4.437 12.498h86.875c5.569 0 10.083-4.515 10.083-10.083v-69.414c0-5.571-4.515-10.086-10.085-10.086zM152.698 316.97c0 6.658-5.398 12.056-12.056 12.056-6.658 0-12.056-5.398-12.056-12.056v-69.596c0-6.658 5.398-12.056 12.056-12.056 6.658 0 12.056 5.398 12.056 12.056v69.596zm310.755-20.988h-31.6v-12.041h31.6v12.041z"
        data-original="#000000"
      />
      <path
        d="m315.805 325.767-8.188 28.028v86.777h-37.929l-12.685 24.113h52.405c-.579-5.552.081-11.207 2.005-16.624l20.318-57.222v-40.06l-15.926-25.012zM416.914 50.634c-20.845-7.959-44.195 2.487-52.154 23.332-8.029 21.025 2.701 44.277 23.332 52.154 20.656 7.888 44.136-2.332 52.154-23.332 7.958-20.845-2.487-44.195-23.332-52.154z"
        data-original="#000000"
      />
    </g>
  </svg>
)

export default SeparationIcon;
